import { Stack } from 'expo-router';
import { Platform } from 'react-native';
import { usePopToTabRoot } from '../../../src/hooks/usePopToTabRoot';
import { colors } from '../../../src/theme/colors';

// The leads list is the base of this tab's stack; lead detail / new / edit
// push on top of it.
export const unstable_settings = {
  initialRouteName: 'leads',
};

// Opaque app-base color so this tab's screens hide the inactive (mounted)
// tabs behind them — no bleed — and blend with the chrome rather than reading
// as a separate colored container.
const contentBackground = colors.background.primary;

export default function LeadsStackLayout() {
  usePopToTabRoot('(leads)', '/leads');

  return (
    <Stack
      screenOptions={({ route }) => {
        const shared = {
          headerShown: false,
          contentStyle: { backgroundColor: contentBackground },
        };

        if (
          route.name === 'lead/new' ||
          route.name === 'lead/edit/[id]' ||
          route.name === 'lead/[id]/index'
        ) {
          return {
            ...shared,
            animation: Platform.OS === 'web' ? ('fade' as const) : ('slide_from_right' as const),
            animationDuration: Platform.OS === 'web' ? 180 : 320,
            gestureEnabled: Platform.OS !== 'web',
          };
        }

        return { ...shared, animation: 'fade' as const };
      }}
    />
  );
}
